import { BaseControlBehaviour } from './BaseControlBehaviour';
/**
 * Enter - устанавливает keydown и обрабатывает enter
 * если дополнительно указан bb-enter-btn то считаем что в аттрибуте лежат контролы разделенные | на которые будет повешен keydown, а элемент на котором bb-enter будет кликаться
 * если не указан то считаем что на данный элемент надо повесить keydown а контролы для клика указаны в значении аттрибута bb-enter
 */
export class EnterBehaviour extends BaseControlBehaviour {
    constructor() {
        super('enter');
    }

    getInstalledTag() {
        return this.tagInstalled;
    }

    protected installBehaviour(element: HTMLElement): void {
        const fromBtn = $(element).attr(this.tag + '-btn');
        const idCtrls = this.getBehaviorValue(element).split('|');
        if (fromBtn) {
            for (let i = 0; i < idCtrls.length; i++) {
                this.setKeydown($('#' + idCtrls[i]), element);
            }
        } else {
            for (let i = 0; i < idCtrls.length; i++) {
                this.setKeydown(element, $('#' + idCtrls[i]));
            }
        }
    }

    private setKeydown(element: any, clickElement: any) {
        $(element).keydown((e) => {
            if (e.which === 13) {
                e.stopPropagation();
                e.preventDefault();

                clickElement.click();
            }
        });
    }
}

if(!window.Behaviours) window.Behaviours = {};
window.Behaviours.EnterBehaviour = EnterBehaviour;